import { render, staticRenderFns } from "./productTypeDetail.vue?vue&type=template&id=6618479e&scoped=true&"
import script from "./productTypeDetail.vue?vue&type=script&lang=js&"
export * from "./productTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618479e",
  null
  
)

export default component.exports